import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "demo-image__preview" }
const _hoisted_3 = { class: "action-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      class: "form",
      ref: "productForm",
      model: _ctx.productInfo,
      "label-width": "150px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "商品ID" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.product_id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.product_id) = $event)),
              maxlength: "50",
              disabled: Boolean(_ctx.route.query.id),
              onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getProductInfo(_ctx.product_id, 1)))
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "商品名称" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.productInfo.title,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.productInfo.title) = $event)),
              disabled: true
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "品牌" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.productInfo.brand_name,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.productInfo.brand_name) = $event)),
              disabled: true
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "品类" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.BrandCat[_ctx.productInfo.cat_id],
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.BrandCat[_ctx.productInfo.cat_id]) = $event)),
              disabled: true
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "售价" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.productInfo.price,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.productInfo.price) = $event)),
              disabled: true
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_el_table, {
      data: _ctx.tableData,
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, { type: "index" }),
        _createVNode(_component_el_table_column, { label: "推荐商品ID" }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_input, {
              modelValue: scope.row.product_id,
              "onUpdate:modelValue": ($event: any) => ((scope.row.product_id) = $event),
              placeholder: "请输入推荐商品ID",
              onBlur: ($event: any) => (_ctx.getProductInfo(scope.row.product_id, 2, _ctx.product_id, scope.$index))
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "title",
          label: "商品名称"
        }),
        _createVNode(_component_el_table_column, {
          prop: "price",
          label: "售价"
        }),
        _createVNode(_component_el_table_column, {
          label: "商品图",
          width: "120"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_2, [
              (scope.row.image_path)
                ? (_openBlock(), _createBlock(_component_el_image, {
                    key: 0,
                    src: scope.row.image_path,
                    style: {"width":"100px"},
                    "preview-src-list": scope.row.image_path.split(',')
                  }, null, 8, ["src", "preview-src-list"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: ($event: any) => (_ctx.onDel(scope.row, scope.$index))
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode("删除")
                ])),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_row, {
      gutter: 10,
      type: "flex",
      justify: "end"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 2 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              class: "full-button",
              type: "primary",
              onClick: _ctx.onAdd
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode("添 加")
              ])),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 2 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              class: "full-button",
              type: "success",
              onClick: _ctx.onSave
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createTextVNode("保 存")
              ])),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 2 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              class: "full-button",
              plain: "",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.router.go(-1)))
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode("返 回")
              ])),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}